import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { BellOutlined, LogoutOutlined, SettingOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Dropdown, Layout, notification, Row, Space, Typography } from "antd";

// Import the HelpButton component
import HelpButton from "./custom/HelpButton";

const { Header } = Layout;
const { Link, Text, Title } = Typography;

const close = () => {
  console.log(
    "Notification was closed. Either the close button was clicked or duration time elapsed.",
  );
};

function LayoutHeader(props) {
  //DECLARED VARIABLES
  const { userData, colorBgContainer, collapsed, setCollapsed, currentStep } = props;
  const { username, roles } = userData;
  console.log("userData", userData);
  const roleName = userData?.roles[0]?.name;
  const [open, setOpen] = useState(false);

  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const menuItems = [
    {
      key: "profile",
      icon: <UserOutlined />,
      label: "My Profile",
      onClick: () => navigate("/profile"),
    },
    // {
    //   key: "settings",
    //   icon: <SettingOutlined />,
    //   label: "Settings",
    //   onClick: () => navigate("/settings"),
    // },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined style={{ color: "#ff4d4f" }} />,
      label: <span style={{ color: "#ff4d4f" }}>Logout</span>,
      onClick: () => navigate("/sign-in"),
    },
  ];
  const openNotification = () => {
    const key = `open${Date.now()}`;
    const btn = (
      <Space>
        <Button type="link" size="small" onClick={() => api.destroy()}>
          Destroy All
        </Button>
        <Button type="primary" size="small" onClick={() => api.destroy(key)}>
          Confirm
        </Button>
      </Space>
    );

    api.open({
      message: "Notification Title",
      description:
        'A function will be be called after the notification is closed (automatically after the "duration" time of manually).',
      btn,
      key,
      onClose: close,
    });
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Header
      style={{
        padding: 0,
        background: colorBgContainer,
        display: "flex",
        alignItems: "center",
        backgroundColor: "#F7F9FC",
      }}
    >
      <Row
        style={{
          marginLeft: "auto",
          marginRight: 20,
          alignItems: "center",
        }}
      >
        {/* Help Button */}
        <HelpButton
          style={{
            marginRight: 8,
          }}
          currentStep={currentStep}
        />
        {contextHolder}
        <Button
          type="text"
          icon={<BellOutlined className="of-menu-icon" />}
          onClick={openNotification}
          style={{
            fontSize: "16px",
            width: 50,
            height: 64,
            marginRight: 10,
          }}
        />
        <Dropdown menu={{ items: menuItems }} placement="bottomRight" arrow trigger={["click"]}>
          <div
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Avatar
              icon={<UserOutlined className="of-menu-icon" />}
              style={{
                fontSize: "16px",
                width: 50,
                height: 64,
                backgroundColor: "transparent",
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                lineHeight: "1.2",
              }}
            >
              <Title level={5} style={{ margin: 0 }}>
                {username || "User"}
              </Title>
              <span style={{ color: "#rgba(255,255,255,0.7)", fontSize: "12px" }}>
                {roleName || "Role"}
              </span>
            </div>
          </div>
        </Dropdown>
      </Row>
    </Header>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutHeader);
